import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { USER_PERMISSIONS } from 'app-models';
import { Subject, combineLatest } from 'rxjs';
import * as errorUtils from 'error-message-utility';
import * as i2 from 'sub-task-petition-details';
import * as i3 from 'cache-country-list';
import * as i5 from '@angular/common';
import * as i6 from 'primeng/dropdown';
import * as i7 from 'primeng/api';
import * as i8 from 'primeng/multiselect';
import { PrimengLibraryModule } from 'primeng-library';

class VdConfigPetitionSubTaskService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getConsulateAddressByContry(countryCode) {
        return this.httpClient.get(`/vd/consulates/${countryCode}`).pipe(map((response) => response.data));
    }
}
VdConfigPetitionSubTaskService.ɵfac = function VdConfigPetitionSubTaskService_Factory(t) { return new (t || VdConfigPetitionSubTaskService)(i0.ɵɵinject(i1.HttpClient)); };
VdConfigPetitionSubTaskService.ɵprov = i0.ɵɵdefineInjectable({ token: VdConfigPetitionSubTaskService, factory: VdConfigPetitionSubTaskService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdConfigPetitionSubTaskService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function VdConfigPetitionSubTaskComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} }
function VdConfigPetitionSubTaskComponent_div_4_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r11.selectedSignatory == null ? null : ctx_r11.selectedSignatory.firstName) + " " + (ctx_r11.selectedSignatory == null ? null : ctx_r11.selectedSignatory.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VdConfigPetitionSubTaskComponent_div_4_ng_template_5_div_0_Template, 3, 1, "div", 5);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r8.selectedSignatory);
} }
function VdConfigPetitionSubTaskComponent_div_4_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r12 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r12 == null ? null : employee_r12.firstName) + " " + (employee_r12 == null ? null : employee_r12.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_4_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function VdConfigPetitionSubTaskComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "label", 8);
    i0.ɵɵtext(3, "Signatory Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 9);
    i0.ɵɵtemplate(5, VdConfigPetitionSubTaskComponent_div_4_ng_template_5_Template, 1, 1, "ng-template", 10);
    i0.ɵɵtemplate(6, VdConfigPetitionSubTaskComponent_div_4_ng_template_6_Template, 3, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, VdConfigPetitionSubTaskComponent_div_4_span_7_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 7);
    i0.ɵɵelementStart(9, "label", 13);
    i0.ɵɵtext(10, "Designation");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r1.reviewUsersList);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.petitionTaskForm.get("authorizedSignatoryId").touched && (ctx_r1.petitionTaskForm.get("authorizedSignatoryId").errors == null ? null : ctx_r1.petitionTaskForm.get("authorizedSignatoryId").errors.required));
} }
function VdConfigPetitionSubTaskComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} }
function VdConfigPetitionSubTaskComponent_div_6_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("REQUIRED"), " ");
} }
function VdConfigPetitionSubTaskComponent_div_6_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.getGlobalErrorMessages("REQUIRED"), " ");
} }
function VdConfigPetitionSubTaskComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "label", 8);
    i0.ɵɵtext(3, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 16);
    i0.ɵɵlistener("onChange", function VdConfigPetitionSubTaskComponent_div_6_Template_p_dropdown_onChange_4_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.getConsulateAddressByCountry(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, VdConfigPetitionSubTaskComponent_div_6_span_5_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelementStart(7, "label", 8);
    i0.ɵɵtext(8, "Select Consulate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "p-dropdown", 17);
    i0.ɵɵtemplate(10, VdConfigPetitionSubTaskComponent_div_6_span_10_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r3.countryList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.petitionTaskForm.get("countryId").touched && (ctx_r3.petitionTaskForm.get("countryId").errors == null ? null : ctx_r3.petitionTaskForm.get("countryId").errors.required));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r3.consulateList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.petitionTaskForm.get("consulateId").touched && (ctx_r3.petitionTaskForm.get("consulateId").errors == null ? null : ctx_r3.petitionTaskForm.get("consulateId").errors.required));
} }
function VdConfigPetitionSubTaskComponent_div_8_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r19.selectedPreparer == null ? null : ctx_r19.selectedPreparer.firstName) + " " + (ctx_r19.selectedPreparer == null ? null : ctx_r19.selectedPreparer.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_8_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VdConfigPetitionSubTaskComponent_div_8_ng_template_10_div_0_Template, 3, 1, "div", 5);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r17.selectedPreparer);
} }
function VdConfigPetitionSubTaskComponent_div_8_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r20 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r20 == null ? null : employee_r20.firstName) + " " + (employee_r20 == null ? null : employee_r20.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelementStart(3, "label", 13);
    i0.ɵɵtext(4, "Lawfirm");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "p-dropdown", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵelementStart(7, "label", 13);
    i0.ɵɵtext(8, "Authorized Signatory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p-dropdown", 19);
    i0.ɵɵtemplate(10, VdConfigPetitionSubTaskComponent_div_8_ng_template_10_Template, 1, 1, "ng-template", 10);
    i0.ɵɵtemplate(11, VdConfigPetitionSubTaskComponent_div_8_ng_template_11_Template, 3, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("options", ctx_r4.attorneys);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r4.attorneyUsers);
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_13_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r25.selectedPreparer == null ? null : ctx_r25.selectedPreparer.firstName) + " " + (ctx_r25.selectedPreparer == null ? null : ctx_r25.selectedPreparer.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VdConfigPetitionSubTaskComponent_div_9_ng_template_13_div_0_Template, 3, 1, "div", 5);
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r21.selectedPreparer);
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r26 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r26 == null ? null : employee_r26.firstName) + " " + (employee_r26 == null ? null : employee_r26.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_19_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r27.selectedLawFirmUsersTextArr.join(", "));
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Select");
    i0.ɵɵelementEnd();
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VdConfigPetitionSubTaskComponent_div_9_ng_template_19_div_0_Template, 2, 1, "div", 5);
    i0.ɵɵtemplate(1, VdConfigPetitionSubTaskComponent_div_9_ng_template_19_div_1_Template, 2, 0, "div", 5);
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r23.selectedLawFirmUsers.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r23.selectedLawFirmUsers.length);
} }
function VdConfigPetitionSubTaskComponent_div_9_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r29 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((employee_r29 == null ? null : employee_r29.firstName) + " " + (employee_r29 == null ? null : employee_r29.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h5", 20);
    i0.ɵɵtext(2, "Lawfirm Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵelementStart(5, "label", 23);
    i0.ɵɵtext(6, "Firm Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 24);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelementStart(10, "label", 25);
    i0.ɵɵtext(11, "Authorized Signatory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p-dropdown", 26);
    i0.ɵɵlistener("onChange", function VdConfigPetitionSubTaskComponent_div_9_Template_p_dropdown_onChange_12_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.userPreparerSelected(); });
    i0.ɵɵtemplate(13, VdConfigPetitionSubTaskComponent_div_9_ng_template_13_Template, 1, 1, "ng-template", 10);
    i0.ɵɵtemplate(14, VdConfigPetitionSubTaskComponent_div_9_ng_template_14_Template, 3, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 7);
    i0.ɵɵelementStart(16, "label", 25);
    i0.ɵɵtext(17, "Lawfirm Users");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "p-multiSelect", 27);
    i0.ɵɵlistener("onChange", function VdConfigPetitionSubTaskComponent_div_9_Template_p_multiSelect_onChange_18_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.usersLawFrimSelected(); });
    i0.ɵɵtemplate(19, VdConfigPetitionSubTaskComponent_div_9_ng_template_19_Template, 2, 2, "ng-template", 28);
    i0.ɵɵtemplate(20, VdConfigPetitionSubTaskComponent_div_9_ng_template_20_Template, 2, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", (ctx_r5.employeeDetails == null ? null : ctx_r5.employeeDetails.companyName) ? ctx_r5.employeeDetails == null ? null : ctx_r5.employeeDetails.companyName : "--", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r5.attorneyUsers);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r5.lawFirmUsersList);
} }
function VdConfigPetitionSubTaskComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} }
function VdConfigPetitionSubTaskComponent_div_11_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r36.selectedPetetionPreprarer == null ? null : ctx_r36.selectedPetetionPreprarer.firstName) ? (ctx_r36.selectedPetetionPreprarer == null ? null : ctx_r36.selectedPetetionPreprarer.firstName) + " " + (ctx_r36.selectedPetetionPreprarer == null ? null : ctx_r36.selectedPetetionPreprarer.lastName) : "--");
} }
function VdConfigPetitionSubTaskComponent_div_11_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VdConfigPetitionSubTaskComponent_div_11_ng_template_5_div_0_Template, 3, 1, "div", 5);
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r33.selectedPetetionPreprarer);
} }
function VdConfigPetitionSubTaskComponent_div_11_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r37 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r37 == null ? null : employee_r37.firstName) + " " + (employee_r37 == null ? null : employee_r37.lastName));
} }
function VdConfigPetitionSubTaskComponent_div_11_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.getGlobalErrorMessages("REQUIRED"), " ");
} }
function VdConfigPetitionSubTaskComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "label", 8);
    i0.ɵɵtext(3, "Petition preparer name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 29);
    i0.ɵɵtemplate(5, VdConfigPetitionSubTaskComponent_div_11_ng_template_5_Template, 1, 1, "ng-template", 10);
    i0.ɵɵtemplate(6, VdConfigPetitionSubTaskComponent_div_11_ng_template_6_Template, 3, 1, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, VdConfigPetitionSubTaskComponent_div_11_span_7_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r7.users);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.petitionTaskForm.get("immSpecialistId").touched && (ctx_r7.petitionTaskForm.get("immSpecialistId").errors == null ? null : ctx_r7.petitionTaskForm.get("immSpecialistId").errors.required));
} }
class VdConfigPetitionSubTaskComponent {
    constructor(fb, apiService, parentFor, cacheCountryService, vdConfigPetitionSubTaskService) {
        this.fb = fb;
        this.apiService = apiService;
        this.parentFor = parentFor;
        this.cacheCountryService = cacheCountryService;
        this.vdConfigPetitionSubTaskService = vdConfigPetitionSubTaskService;
        this.serviceCenters = [];
        this.reviewUsersList = [];
        this.attorneys = [];
        this.attorneyUsers = [];
        this.users = [];
        this.isOutsideImagility = true;
        this.petitionUpdates = [false, false];
        this.consulateList = [];
        this.countryList = [];
        // foreignCompanyList: any[] = [];
        // companyRelationList: ReferenceLibrary[] = [];
        // fieldExtrAbltyCodeList: ReferenceLibrary[] = [];
        // extraBLDOCEVDNCATGList: ReferenceLibrary[] = [];
        // majorInternationAwardList: any[] = [];
        // applicableOptionItem = [{
        //   code: String,
        //   name: String,
        //   description: String
        // }]
        // public checksForOVisa: [
        //   {
        //     code: String,
        //     name: String,
        //     description: String
        //   }
        // ];
        this.observableSubscription$ = new Subject();
        this.ngUnsubscribe = new Subject();
        this.subTaskDetails = null;
        this.fields = {
            showServiceCenterSection: true,
            showSignatorySection: true,
            showAttorneySection: true,
            showPetitionerSection: true,
            showConsulateSection: true,
            hideOnlyServiceCenterDropdown: false
        };
        this.lawFirmUsersList = [];
        this.selectedLawFirmUsers = [];
        this.selectedLawFirmUsersTextArr = [];
        this.disabledProcessingType = true;
        this.serviceCenterFieldPlcaeholder = 'Select Service Center';
        this.showSignatorySection = false;
    }
    // customOnChanges() {
    //   console.log(this.i485SuperTask);
    // }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.form = this.parentFor.form;
        //IM-20705 - Enabling the processing types for H4 visas as it is required to enter the premium processing fee
        this.disabledProcessingType = !((['I129EFILING'].includes((_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.subTaskTypeCode) && !this.subTaskDetails.receiptDate && (!this.subTaskDetails.receiptNumber || this.subTaskDetails.receiptNumber === '')));
        const isClassificationValid = ['EB4IMMOTH', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR'].includes((_c = (_b = this.subTaskDetails) === null || _b === void 0 ? void 0 : _b.taskTypeDetails) === null || _c === void 0 ? void 0 : _c.immClassificationCode);
        const hasSubTaskDetails = !!this.subTaskDetails; // Check if subTaskDetails exists
        const isIndividualSponsor = (_d = this.subTaskDetails) === null || _d === void 0 ? void 0 : _d.isIndividualSponsor; // Boolean, directly use it
        this.showSignatorySection = isClassificationValid && hasSubTaskDetails && isIndividualSponsor;
        this.setFieldConfiguration();
        this.primaryCompanyId =
            ((_f = (_e = this.form.get('newTaskForm')) === null || _e === void 0 ? void 0 : _e.get('companyId')) === null || _f === void 0 ? void 0 : _f.value) ?
                parseInt(this.form.get('newTaskForm').get('companyId').value) : null;
        (_h = (_g = this.form.controls['newTaskForm']) === null || _g === void 0 ? void 0 : _g.controls['companyId']) === null || _h === void 0 ? void 0 : _h.valueChanges.subscribe((data) => {
            this.primaryCompanyId = data;
            // Hide section IMGLT-568
            // if (this.fields.showServiceCenterSection) {
            //   if (this.subTaskDetails?.processingType) {
            //     this.petitionTaskForm.patchValue({ processingType: this.subTaskDetails.processingType });
            //   }
            //   this.onChangeProcessingType();
            // } 
            let isOnlySignatory = true; // to load the signatory users    
            if (data !== null) {
                combineLatest([
                    this.apiService.getReviewersUser(this.form.get('newTaskForm').get('companyId').value, USER_PERMISSIONS.PETITION_REVIEWER, isOnlySignatory),
                    this.apiService.getActiveAttorneyCompanyList(this.form.get('newTaskForm').get('companyId').value),
                    this.apiService.getUsersOfCompany(this.form.get('newTaskForm').get('companyId').value)
                ])
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(subData => {
                    this.reviewUsersList = subData[0];
                    this.attorneys = Object.assign([], [{ attorneyId: null, attorneyName: "Select attorney" }, ...subData[1]]);
                    this.users = subData[2];
                    if (this.i485SuperTask) {
                        this.petitionTaskForm.patchValue({
                            authorizedSignatoryId: this.i485SuperTask ?
                                this.reviewUsersList.some(user => user.id === this.i485SuperTask.signatoryId) ?
                                    this.i485SuperTask.signatoryId : null : null,
                            selectedDesignation: null,
                            immSpecialistId: this.i485SuperTask ?
                                this.users.some(user => user.id === this.i485SuperTask.immSpecialistId) ?
                                    this.i485SuperTask.immSpecialistId : (this.subTaskDetails && this.subTaskDetails.immSpecialistId ? this.subTaskDetails.immSpecialistId : null) : null
                        });
                    }
                    else if (this.ds160SuperTask) {
                        try {
                            this.petitionTaskForm.patchValue({
                                authorizedSignatoryId: this.ds160SuperTask && this.reviewUsersList ?
                                    this.reviewUsersList.some(user => user.id === this.ds160SuperTask.signatoryId) ?
                                        this.ds160SuperTask.signatoryId : null : null,
                                selectedDesignation: null,
                                immSpecialistId: this.ds160SuperTask ?
                                    this.users.some(user => user.id === this.ds160SuperTask.immSpecialistId) ?
                                        this.ds160SuperTask.immSpecialistId : (this.subTaskDetails && this.subTaskDetails.immSpecialistId ? this.subTaskDetails.immSpecialistId : null) : null
                            });
                        }
                        catch (error) {
                            console.log("error", error);
                        }
                    }
                    else {
                        if (this.subTaskDetails && this.subTaskDetails.signatoryId) {
                            this.petitionTaskForm.patchValue({
                                authorizedSignatoryId: this.subTaskDetails.signatoryId
                            });
                        }
                        if (this.subTaskDetails && this.subTaskDetails.immSpecialistId) {
                            this.petitionTaskForm.patchValue({ immSpecialistId: this.subTaskDetails.immSpecialistId });
                            this.onPetitionerPreparerSelected();
                        }
                    }
                    if (this.petitionTaskForm.get('authorizedSignatoryId') && this.petitionTaskForm.get('authorizedSignatoryId').value) {
                        this.userSelected();
                    }
                });
            }
            // individual / sponsor remove petitioner preparer's validation
            if (data === 0) {
                this.petitionTaskForm.get('immSpecialistId').setValidators(null);
                this.petitionTaskForm.get('immSpecialistId').updateValueAndValidity();
            }
        });
        if (this.userType !== 'Attorney') {
            this.petitionTaskForm.patchValue({
                attorneyId: this.subTaskDetails && this.subTaskDetails.attorneyId,
                preparerAttorneyId: 0
            });
            this.isAttorneySelect = true;
            if (this.subTaskDetails && this.subTaskDetails.attorneyId) {
                this.attorneySelected();
            }
        }
        else {
            this.isAttorneySelect = false;
            // if (this.form.get('newTaskForm').get('companyId').value) {
            // this.getForeignCompanyListForAttorney();
            // }
            this.apiService.getEmployeeDetails(parseInt(sessionStorage.getItem('companyId')), parseInt(sessionStorage.getItem('employeeId')))
                .pipe(take(1))
                .subscribe((response) => {
                this.employeeDetails = response;
                //sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
                this.petitionTaskForm.patchValue({
                    attorneyId: response.companyId,
                });
                this.attorneySelected();
                //  this.getQuestionListForCreateTask();
            });
        }
        if (this.petitionTaskForm.get('processingType')) {
            this.petitionTaskForm.get('processingType').valueChanges.subscribe(data => {
                if (data) {
                    this.onChangeProcessingType();
                }
            });
        }
        if (this.petitionTaskForm.get('immSpecialistId')) {
            this.petitionTaskForm.get('immSpecialistId').valueChanges.subscribe(data => {
                if (data && this.users && this.users.length > 0) {
                    this.onPetitionerPreparerSelected();
                }
            });
        }
        if (this.petitionTaskForm.get('authorizedSignatoryId')) {
            this.petitionTaskForm.get('authorizedSignatoryId').valueChanges.subscribe(data => {
                if (data && this.reviewUsersList && this.reviewUsersList.length > 0) {
                    this.userSelected();
                }
            });
        }
        if (this.petitionTaskForm.get('attorneyId')) {
            this.petitionTaskForm.get('attorneyId').valueChanges.subscribe(data => {
                this.attorneySelected();
            });
        }
        if (this.petitionTaskForm.get('preparerAttorneyId')) {
            this.petitionTaskForm.get('preparerAttorneyId').valueChanges.subscribe(data => {
                if (data && this.attorneyUsers && this.attorneyUsers.length > 0) {
                    this.userPreparerSelected();
                }
            });
        }
        if (this.petitionTaskForm.get('countryId')) {
            this.petitionTaskForm.get('countryId').valueChanges.subscribe(data => {
                if (data) {
                    this.getConsulateAddressByCountry();
                }
            });
        }
        this.cacheCountryService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
        this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            var _a;
            if (data.listCountries.length > 0) {
                this.countryList = data.listCountries;
                if (this.subTaskDetails && ((_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.consulate)) {
                    this.petitionTaskForm.patchValue({ countryId: this.subTaskDetails.consulate.countryCode.countryCode });
                }
            }
            else {
                this.countryList = [];
            }
        });
        if (['H4'].includes((_k = (_j = this.subTaskDetails) === null || _j === void 0 ? void 0 : _j.taskTypeDetails) === null || _k === void 0 ? void 0 : _k.visaType)) {
            this.serviceCenterFieldPlcaeholder = 'Select Lockbox';
        }
    }
    setFieldConfiguration() {
        if (this.fieldConfiguration && this.fieldConfiguration.length > 0) {
            this.fields.showServiceCenterSection = this.objExists('showServiceCenterSection');
            this.fields.showSignatorySection = this.objExists('showSignatorySection');
            this.fields.showAttorneySection = this.objExists('showAttorneySection');
            this.fields.showPetitionerSection = this.objExists('showPetitionerSection');
            this.fields.showConsulateSection = this.objExists('showConsulateSection');
            this.fields.hideOnlyServiceCenterDropdown = this.objExists('hideOnlyServiceCenterDropdown');
        }
        this.createForm();
    }
    objExists(name) {
        return this.fieldConfiguration.some((el) => {
            if (el.fieldName === name) {
                return el.showField;
            }
        });
    }
    getConsulateAddressByCountry() {
        const countryCode = this.petitionTaskForm.get('countryId').value;
        this.vdConfigPetitionSubTaskService.getConsulateAddressByContry(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            var _a, _b;
            this.consulateList = data;
            if (this.subTaskDetails && ((_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.consulate)) {
                this.petitionTaskForm.patchValue({ consulateId: (_b = this.subTaskDetails.consulate) === null || _b === void 0 ? void 0 : _b.id });
            }
        });
    }
    createForm() {
        this.petitionTaskForm = this.fb.group({
            immigrantTypeCode: [null],
            isAttorneySame: [0],
            isCaseTransferred: [0],
        });
        //  Hide section IMGLT-568
        // if (this.fields.showServiceCenterSection) {
        //   this.petitionTaskForm.addControl('processingType', this.fb.control({ value: 'regular', disabled: this.disabledProcessingType }, [Validators.required]));
        //   if (!this.fields.hideOnlyServiceCenterDropdown) {
        //     this.petitionTaskForm.addControl('serviceCenterId', this.fb.control(null, [Validators.required]));
        //   }
        // }
        if (this.fields.showSignatorySection && !this.showSignatorySection) {
            this.petitionTaskForm.addControl('authorizedSignatoryId', this.fb.control(null, [Validators.required]));
            this.petitionTaskForm.addControl('selectedDesignation', this.fb.control(null));
        }
        if (this.fields.showConsulateSection) {
            this.petitionTaskForm.addControl('consulateId', this.fb.control(null, [Validators.required]));
            this.petitionTaskForm.addControl('countryId', this.fb.control(null));
        }
        if (this.fields.showAttorneySection) {
            this.petitionTaskForm.addControl('attorneyId', this.fb.control(null));
            this.petitionTaskForm.addControl('preparerAttorneyId', this.fb.control(null));
            this.petitionTaskForm.addControl('lawFirmUsers', this.fb.control(null));
        }
        if (this.fields.showPetitionerSection) {
            this.petitionTaskForm.addControl('immSpecialistId', this.fb.control(null, [Validators.required]));
        }
        this.form.addControl('petitionTaskForm', this.petitionTaskForm);
    }
    onChangeProcessingType() {
        this.serviceCenters = [];
        this.getServiceCenter();
    }
    getServiceCenter() {
        var _a, _b, _c, _d, _e, _f;
        const processingType = this.petitionTaskForm.get('processingType').value;
        let petitionType;
        let visaType;
        if (((_b = (_a = this.form.get('newTaskForm')) === null || _a === void 0 ? void 0 : _a.get('taskType')) === null || _b === void 0 ? void 0 : _b.value) === 'NONIMMPET' && !this.templateTaskTypeId) {
            visaType = (_d = (_c = this.form.get('newTaskForm')) === null || _c === void 0 ? void 0 : _c.get('visaType')) === null || _d === void 0 ? void 0 : _d.value;
            petitionType = (_f = (_e = this.form.get('newTaskForm')) === null || _e === void 0 ? void 0 : _e.get('petitionType')) === null || _f === void 0 ? void 0 : _f.value;
            this.apiService.getServiceCenters((processingType === 'regular') ? false : true, visaType, petitionType)
                .subscribe((data) => {
                this.serviceCenters = data;
                if (this.i485SuperTask) {
                    this.setServiceCenter();
                }
                else if (this.subTaskDetails && this.subTaskDetails.serviceCenterId) {
                    this.petitionTaskForm.patchValue({ serviceCenterId: this.subTaskDetails.serviceCenterId });
                }
            });
        }
        else {
            this.apiService.getImmiServiceCenters((processingType === 'regular') ? false : true, this.templateTaskTypeId)
                .subscribe((data) => {
                this.serviceCenters = data;
                if (this.i485SuperTask) {
                    this.setServiceCenter();
                }
                else if (this.subTaskDetails && this.subTaskDetails.serviceCenterId) {
                    this.petitionTaskForm.patchValue({ serviceCenterId: this.subTaskDetails.serviceCenterId });
                }
            });
        }
    }
    setServiceCenter() {
        const serviceCenterId = this.serviceCenters && this.serviceCenters.length > 0 &&
            this.serviceCenters.some(x => x.id === this.i485SuperTask.serviceCenterId) ?
            this.i485SuperTask.serviceCenterId : null;
        this.petitionTaskForm.get('serviceCenterId').patchValue(serviceCenterId);
    }
    userSelected() {
        const id = this.petitionTaskForm.get('authorizedSignatoryId').value;
        this.selectedSignatory = this.reviewUsersList.find(ele => ele.id === id);
        this.petitionTaskForm.patchValue({
            selectedDesignation: this.selectedSignatory.designation
        });
        this.selectedDesignation = this.selectedSignatory.designation;
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    attorneySelected() {
        const attorneyId = this.petitionTaskForm.get('attorneyId').value;
        let isOnlySignatory = false; // to load the signatory users
        if (attorneyId && attorneyId !== '') {
            combineLatest([
                this.apiService.getReviewersUser(attorneyId, USER_PERMISSIONS.PETITION_REVIEWER, isOnlySignatory),
                this.apiService.getUsersOfCompany(attorneyId),
            ])
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(data => {
                this.attorneyUsers = data ? data[0] : [];
                this.lawFirmUsersList = data ? data[1] : [];
                if (this.i485SuperTask) {
                    this.petitionTaskForm.get('preparerAttorneyId').patchValue(this.i485SuperTask.preparerAttorneyId);
                }
                else if (this.ds160SuperTask) {
                    this.petitionTaskForm.get('preparerAttorneyId').patchValue(this.ds160SuperTask.preparerAttorneyId);
                }
                else if (this.subTaskDetails && this.subTaskDetails.preparerAttorneyId) {
                    this.petitionTaskForm.patchValue({ preparerAttorneyId: this.subTaskDetails.preparerAttorneyId });
                    this.userPreparerSelected();
                }
                if (this.subTaskDetails && this.subTaskDetails.lawFirmUsers) {
                    this.petitionTaskForm.patchValue({ lawFirmUsers: this.subTaskDetails.lawFirmUsers });
                    this.usersLawFrimSelected();
                }
            });
        }
        else {
            this.attorneyUsers = [];
            this.lawFirmUsersList = [];
        }
    }
    userPreparerSelected() {
        var _a;
        const id = this.petitionTaskForm.get('preparerAttorneyId').value;
        this.selectedPreparer = (_a = this.attorneyUsers) === null || _a === void 0 ? void 0 : _a.find(ele => ele.id === id);
        if (this.selectedPreparer) {
            sessionStorage.setItem("setPreparerAttorneyId", this.selectedPreparer['id']);
        }
    }
    usersLawFrimSelected() {
        const ids = this.petitionTaskForm.get('lawFirmUsers').value;
        this.selectedLawFirmUsers = ids.length ? this.lawFirmUsersList.filter(ele => ids.includes(ele.id)) : [];
        this.selectedLawFirmUsersTextArr = [];
        this.selectedLawFirmUsers.forEach((el) => {
            this.selectedLawFirmUsersTextArr.push(`${el.firstName} ${el.lastName}`);
        });
    }
    onPetitionerPreparerSelected() {
        const id = this.petitionTaskForm.get('immSpecialistId').value;
        this.selectedPetetionPreprarer = this.users.find(ele => ele.id === id);
    }
    ngOnDestroy() {
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
        }
        sessionStorage.setItem("setPreparerAttorneyId", "undefined");
    }
}
VdConfigPetitionSubTaskComponent.ɵfac = function VdConfigPetitionSubTaskComponent_Factory(t) { return new (t || VdConfigPetitionSubTaskComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.SubTaskPetitionDetailsService), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective), i0.ɵɵdirectiveInject(i3.CacheCountryListService), i0.ɵɵdirectiveInject(VdConfigPetitionSubTaskService)); };
VdConfigPetitionSubTaskComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdConfigPetitionSubTaskComponent, selectors: [["vd-config-petition-sub-task"]], inputs: { fieldConfiguration: "fieldConfiguration", templateTaskTypeId: "templateTaskTypeId", subTaskDetails: "subTaskDetails", i485SuperTask: "i485SuperTask", ds160SuperTask: "ds160SuperTask" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 12, vars: 8, consts: [["formGroupName", "petitionTaskForm", 1, "col-md-11", "p-mt-2"], [1, "col-md-12"], ["class", "p-grid dashed-line p-my-4", 4, "ngIf"], ["class", "p-fluid p-formgrid p-grid", 4, "ngIf"], [1, "p-grid", "dashed-line", "p-my-4"], [4, "ngIf"], [1, "p-fluid", "p-formgrid", "p-grid"], [1, "p-col-4"], [1, "create-task-label", "required"], ["formControlName", "authorizedSignatoryId", "name", "authorizedSignatoryId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Signatory", "appendTo", "body", 3, "options"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], ["class", "invalid-message", 4, "ngIf"], [1, "create-task-label"], ["type", "text", "readOnly", "", "name", "selectedDesignation", "formControlName", "selectedDesignation", 1, "form-control", "txt-comp"], [1, "invalid-message"], ["formControlName", "countryId", "name", "countryId", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "Select Country", "appendTo", "body", 3, "options", "onChange"], ["formControlName", "consulateId", "name", "consulateId", "optionLabel", "consulateName", "optionValue", "id", "placeholder", "Select Consulate", "appendTo", "body", 3, "options"], ["formControlName", "attorneyId", "name", "attorneyId", "optionLabel", "attorneyName", "optionValue", "attorneyId", "placeholder", "Select Lawfirm", 3, "options"], ["formControlName", "preparerAttorneyId", "name", "preparerAttorneyId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Preparer", "appendTo", "body", 3, "options"], [1, "labelText"], [1, "p-grid"], [1, "p-col-12", "pl-0"], [1, "mt-2", "ml-2", "create-task-label", "label-cls"], [1, "row", "mt-1", "ml-2"], [1, "mt-2", "d-block", "create-task-label"], ["formControlName", "preparerAttorneyId", "name", "preparerAttorneyId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select", "appendTo", "body", 1, "w-100", 3, "options", "onChange"], ["optionValue", "id", "formControlName", "lawFirmUsers", "appendTo", "body", "defaultLabel", "Select", "optionLabel", "firstName", 1, "w-100", 3, "options", "onChange"], ["pTemplate", "selectedItems"], ["formControlName", "immSpecialistId", "name", "immSpecialistId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Petitioner Preparer", "appendTo", "body", 3, "options"]], template: function VdConfigPetitionSubTaskComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, VdConfigPetitionSubTaskComponent_div_3_Template, 1, 0, "div", 2);
        i0.ɵɵtemplate(4, VdConfigPetitionSubTaskComponent_div_4_Template, 12, 2, "div", 3);
        i0.ɵɵtemplate(5, VdConfigPetitionSubTaskComponent_div_5_Template, 1, 0, "div", 2);
        i0.ɵɵtemplate(6, VdConfigPetitionSubTaskComponent_div_6_Template, 11, 4, "div", 3);
        i0.ɵɵelement(7, "div", 4);
        i0.ɵɵtemplate(8, VdConfigPetitionSubTaskComponent_div_8_Template, 12, 2, "div", 5);
        i0.ɵɵtemplate(9, VdConfigPetitionSubTaskComponent_div_9_Template, 21, 3, "div", 5);
        i0.ɵɵtemplate(10, VdConfigPetitionSubTaskComponent_div_10_Template, 1, 0, "div", 2);
        i0.ɵɵtemplate(11, VdConfigPetitionSubTaskComponent_div_11_Template, 8, 2, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.fields.showSignatorySection && !ctx.showSignatorySection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showSignatorySection && !ctx.showSignatorySection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showConsulateSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showConsulateSection);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAttorneySelect && ctx.fields.showAttorneySection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isAttorneySelect && ctx.fields.showAttorneySection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showPetitionerSection && ctx.primaryCompanyId != 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showPetitionerSection && ctx.primaryCompanyId != 0);
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupName, i5.NgIf, i6.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i7.PrimeTemplate, i1$1.DefaultValueAccessor, i8.MultiSelect], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdConfigPetitionSubTaskComponent, [{
        type: Component,
        args: [{
                selector: 'vd-config-petition-sub-task',
                templateUrl: 'vd-config-petition-sub-task.component.html',
                styleUrls: ['vd-config-petition-sub-task.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ]
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.SubTaskPetitionDetailsService }, { type: i1$1.FormGroupDirective }, { type: i3.CacheCountryListService }, { type: VdConfigPetitionSubTaskService }]; }, { fieldConfiguration: [{
            type: Input
        }], templateTaskTypeId: [{
            type: Input
        }], subTaskDetails: [{
            type: Input
        }], i485SuperTask: [{
            type: Input
        }], ds160SuperTask: [{
            type: Input
        }] }); })();

class VdConfigPetitionSubTaskModule {
}
VdConfigPetitionSubTaskModule.ɵfac = function VdConfigPetitionSubTaskModule_Factory(t) { return new (t || VdConfigPetitionSubTaskModule)(); };
VdConfigPetitionSubTaskModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdConfigPetitionSubTaskModule });
VdConfigPetitionSubTaskModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdConfigPetitionSubTaskModule, { declarations: [VdConfigPetitionSubTaskComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [VdConfigPetitionSubTaskComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdConfigPetitionSubTaskModule, [{
        type: NgModule,
        args: [{
                declarations: [VdConfigPetitionSubTaskComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                exports: [VdConfigPetitionSubTaskComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-config-petition-sub-task
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdConfigPetitionSubTaskComponent, VdConfigPetitionSubTaskModule, VdConfigPetitionSubTaskService };
//# sourceMappingURL=vd-config-petition-sub-task.js.map
